import {
  Component,
  Input,
  OnInit
} from '@angular/core';
import {
  PostsService,
  UserModel
} from '@lib/gc-common';

@Component({
  selector: 'mip-stories-avatars',
  templateUrl: './stories-avatars.component.html',
  styleUrls: ['./stories-avatars.component.scss'],
})
export class StoriesAvatarsComponent implements OnInit {
  
  @Input() avatarSize = 70;
  
  storiesAvatars: UserModel[] = [];
  
  constructor(
    private postsService: PostsService
  ) {
  
  }
  
  async ngOnInit() {
    const { list } = await this.postsService.getTrendingPosts({category: 'trending'});
    
    this.storiesAvatars = list.map(post => post.author);
    console.log('stories-avatars.component->ngOnInit(): this.storiesAvatars', this.storiesAvatars)
  }
}
